<template>
  <tr class="rounded-lg text-navy shadow-[2px_2px_0px_0px] shadow-navy">
    <slot />
  </tr>
</template>
